import { render, staticRenderFns } from "./accountPaging.vue?vue&type=template&id=a4f67b6c&scoped=true&"
import script from "./accountPaging.vue?vue&type=script&lang=js&"
export * from "./accountPaging.vue?vue&type=script&lang=js&"
import style0 from "./accountPaging.vue?vue&type=style&index=0&id=a4f67b6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f67b6c",
  null
  
)

export default component.exports